import React from "react";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog";
import {
  Button,
  DataGrid,
  FileUploader,
  LoadPanel,
  NumberBox,
  Popup,
} from "devextreme-react";
import { Column, Paging, Scrolling } from "devextreme-react/data-grid";
import apiAxios from "../../api-axios";

const MENSAGEM_ERRO_GENERICO =
  "Não foi possível importar os arquivos. Nenhum dado foi alterado. Tente novamente.";

export default class ImportarCnpjsTse extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ano: new Date().getFullYear(),
      arquivos: [],
      enviando: false,
      resultado: null,
      resumo: [],
      exibirPopupErros: false,
      erroMensagem: "",
      erros: [],
    };

    this.fileUploaderRef = React.createRef();

    this.onAnoChanged = this.onAnoChanged.bind(this);
    this.onArquivosChanged = this.onArquivosChanged.bind(this);
    this.onImportarClick = this.onImportarClick.bind(this);
    this.carregarResumo = this.carregarResumo.bind(this);
    this.fecharPopupErros = this.fecharPopupErros.bind(this);
  }

  componentDidMount() {
    this.carregarResumo();
  }

  carregarResumo() {
    return apiAxios
      .get("/eleicoes/cnpjs/resumo")
      .then((response) => {
        this.setState({ resumo: Array.isArray(response.data) ? response.data : [] });
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          notify("Apenas usuários Trimap podem importar CNPJs do TSE.", "error");
        } else {
          notify("Não foi possível carregar os CNPJs por ano.", "error");
        }
      });
  }

  onAnoChanged(e) {
    this.setState({ ano: e.value });
  }

  onArquivosChanged(e) {
    this.setState({ arquivos: e.value || [] });
  }

  fecharPopupErros() {
    this.setState({ exibirPopupErros: false });
  }

  async onImportarClick() {
    const { ano, arquivos, resumo } = this.state;
    if (ano === null || ano === undefined || ano === "" || arquivos.length < 2) {
      return;
    }

    const itemResumo = resumo.find((x) => x.ano === ano);
    const quantidade = itemResumo ? itemResumo.quantidade : 0;

    const confirmado = await confirm(
      `Os ${quantidade} CNPJs de ${ano} carregados hoje serão substituídos pelos destes arquivos. Continuar?`,
      "Confirmar importação"
    );
    if (confirmado !== true) {
      return;
    }

    const formData = new FormData();
    arquivos.forEach((arquivo) => {
      formData.append("arquivos", arquivo, arquivo.name);
    });

    this.setState({ enviando: true });
    try {
      const response = await apiAxios.post(`/eleicoes/cnpjs/${ano}`, formData);
      this.setState({ resultado: response.data, arquivos: [] });
      if (this.fileUploaderRef.current) {
        this.fileUploaderRef.current.instance.reset();
      }
      notify("Importação concluída.", "success");
      this.carregarResumo();
    } catch (error) {
      const status = error.response ? error.response.status : null;
      if (status === 400) {
        const corpo = error.response.data || {};
        this.setState({
          exibirPopupErros: true,
          erroMensagem: corpo.mensagem || "",
          erros: Array.isArray(corpo.erros) ? corpo.erros : [],
        });
      } else if (status === 403) {
        notify("Apenas usuários Trimap podem importar CNPJs do TSE.", "error");
      } else {
        notify(MENSAGEM_ERRO_GENERICO, "error");
      }
    } finally {
      this.setState({ enviando: false });
    }
  }

  renderResultado() {
    const { resultado } = this.state;
    if (!resultado) {
      return null;
    }

    const duracaoSegundos = ((resultado.duracaoMs || 0) / 1000).toLocaleString("pt-BR", {
      maximumFractionDigits: 1,
    });

    return (
      <div style={{ marginTop: "25px" }}>
        <h4>Resultado da importação de {resultado.ano}</h4>
        <DataGrid
          dataSource={resultado.arquivos || []}
          showBorders={true}
          columnAutoWidth={true}
        >
          <Paging enabled={false} />
          <Column dataField="arquivo" caption="Arquivo" />
          <Column
            dataField="dataGeracao"
            caption="Data de geração"
            dataType="datetime"
            format="dd/MM/yyyy HH:mm"
            calculateCellValue={(row) =>
              row.dataGeracao ? new Date(row.dataGeracao) : null
            }
          />
          <Column dataField="lidos" caption="Lidos" dataType="number" />
          <Column dataField="candidatos" caption="Candidatos" dataType="number" />
          <Column dataField="partidos" caption="Partidos" dataType="number" />
        </DataGrid>
        <div style={{ marginTop: "10px" }}>
          <div>Removidos: {resultado.removidos}</div>
          <div>Gravados: {resultado.gravados}</div>
          <div>Duração: {duracaoSegundos} s</div>
        </div>
      </div>
    );
  }

  render() {
    const { ano, arquivos, enviando, resumo } = this.state;
    const anoVazio = ano === null || ano === undefined || ano === "";
    const importarDesabilitado = anoVazio || arquivos.length < 2 || enviando;

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <h3>Importar CNPJs do TSE</h3>
          <p>
            Selecione o arquivo de candidatos e o de partidos publicados pelo TSE. A
            importação substitui todos os CNPJs do ano informado.
          </p>

          <div style={{ maxWidth: "200px", marginBottom: "15px" }}>
            <NumberBox
              label="Ano da eleição"
              labelMode="static"
              value={ano}
              min={2000}
              format="#"
              showSpinButtons={true}
              onValueChanged={this.onAnoChanged}
            />
          </div>

          <FileUploader
            ref={this.fileUploaderRef}
            multiple={true}
            uploadMode="useForm"
            accept=".txt"
            allowedFileExtensions={[".txt"]}
            maxFileSize={104857600}
            selectButtonText="Selecionar arquivos"
            labelText="ou arraste os arquivos aqui"
            onValueChanged={this.onArquivosChanged}
          />

          <Button
            text="Importar"
            type="default"
            disabled={importarDesabilitado}
            onClick={this.onImportarClick}
          />

          <LoadPanel
            visible={enviando}
            message="Importando CNPJs..."
            showIndicator={true}
            shading={true}
          />

          {this.renderResultado()}

          <div style={{ marginTop: "25px" }}>
            <h4>CNPJs carregados por ano</h4>
            <DataGrid dataSource={resumo} showBorders={true} columnAutoWidth={true}>
              <Paging enabled={false} />
              <Scrolling mode="standard" />
              <Column dataField="ano" caption="Ano" dataType="number" format="#" />
              <Column dataField="quantidade" caption="Quantidade" dataType="number" />
            </DataGrid>
          </div>
        </div>

        <Popup
          visible={this.state.exibirPopupErros}
          onHiding={this.fecharPopupErros}
          title="Arquivos não importados"
          showCloseButton={true}
          dragEnabled={false}
          width={600}
          height="auto"
          maxHeight="80%"
        >
          <div>
            <p>{this.state.erroMensagem}</p>
            <ul>
              {this.state.erros.map((erro, indice) => (
                <li key={indice}>{erro}</li>
              ))}
            </ul>
          </div>
        </Popup>
      </React.Fragment>
    );
  }
}
